import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Header from "../Header";
import Input from "../Input/Input";

const AccessoriesMerchantForm = () => {
  const navigate = useNavigate();
  const { accessoriesMerchantId } = useParams();

  const [formData, setFormData] = useState({
    accessoriesMerchantName: "",
    seasonId: "",
  });

  useEffect(() => {
    if (accessoriesMerchantId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}accessories-merchants/view`,
          {
            accessoriesMerchantId: accessoriesMerchantId,
          },
        );

        if (response.data.data) {
          setFormData(response.data.data[0]);
        }
      })();
    }
  }, [accessoriesMerchantId]);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response = await axios.post(
          `${settings.api}accessories-merchants/${
            accessoriesMerchantId ? "update" : "create"
          }`,
          formData,
        );

        if (response.data.statusCode === 200) {
          navigate("/accessories-merchants");
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره تاجر اكسسوارات" />

        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Input
            label="اسم تاجر الاكسسوارات"
            value={formData.accessoriesMerchantName}
            onChange={onChange}
            required
            name="accessoriesMerchantName"
          />

          <Button
            type="submit"
            text="تسجيل"
            isDisabled={!formData.accessoriesMerchantName}
          />
        </div>
      </div>
    </form>
  );
};

export default AccessoriesMerchantForm;
